export default __webpack_public_path__ + "static/media/photo--lg--41.32e0e8e6.jpg";